import {
  NavbarGroup,
  navbarGroupIdAdmin,
  navbarGroupIdDashboard,
  navbarGroupIdMatters,
  navbarGroupIdRequests,
  navbarGroupIdServedDocManager,
  NavbarHeader,
  NavbarItem
} from '@safarilaw-webapp/shared/app-bootstrap/data-access';
import { NavbarItemId } from '@safarilaw-webapp/shared/common-objects-models';
import { environmentImports } from './navbar-item-collection.env.imports';

export const NavbarItemCollection = [
  new NavbarGroup(navbarGroupIdDashboard, 'DASHBOARD', ['isAuthenticated']),
  new NavbarHeader(NavbarItemId.ActionAlerts, navbarGroupIdDashboard, 'Action Alerts', 's_mnu-link-alert', ['isAuthenticated', '!isCurrentUserUploader'], '/legal-process/action-alerts'),
  new NavbarHeader({
    id: NavbarItemId.Tasks,
    groupId: navbarGroupIdDashboard,
    title: 'Tasks (30 days)',
    elementId: 's_mnu-link-tasks',
    permissionFunction: ['isAuthenticated', '!isCurrentUserUploader', 'isTasksEnabled'],
    link: '/legal-process/tasks/my-tasks-30-days',
    // Every tab is its own route, so the item stays lit on any of them.
    activeChildPaths: ['/legal-process/tasks'],
    dataTestId: 'navbar-tasks-5d2b8e'
  }),
  new NavbarHeader(
    NavbarItemId.Notifications,
    navbarGroupIdDashboard,
    'Notifications',
    's_mnu-link-bell',
    ['isAuthenticated', 'isFeatureFlagEnabled|notificationBellEnabled'],
    '/legal-process/notifications'
  ),
  // SERVED DOC MANAGER section (feature 12246) — supersedes the former interim "AI Intake" dashboard
  // link, so it keeps that link's company gate (isServedDocumentManagerEnabled) and adds the spec's per-user SDM
  // access gate (canAccessIntakeEvents). Sits directly below the dashboard/alerts group and above
  // MATTERS. Two filtered views of the intake events list; badge counts are pending an intake-events
  // count API. Icons reuse the Matters intake/inbox glyphs for now.
  new NavbarGroup(navbarGroupIdServedDocManager, 'SERVED DOC MANAGER', ['isAuthenticated', 'isServedDocumentManagerEnabled', 'canAccessIntakeEvents']),
  new NavbarHeader({
    id: NavbarItemId.NeedsReview,
    groupId: navbarGroupIdServedDocManager,
    title: 'New Intake',
    elementId: 's_mnu-link-new-intake',
    permissionFunction: ['isAuthenticated', 'isServedDocumentManagerEnabled', 'canAccessIntakeEvents'],
    link: '/legal-process/intake-events/needs-review',
    // Explicit, stable test id (kept independent of the title so it stays put across label changes).
    dataTestId: 'navbar-sdm-unassigned-7f21c9'
  }),
  new NavbarHeader(
    NavbarItemId.MyQueue,
    navbarGroupIdServedDocManager,
    'My Queue',
    's_mnu-link-my-queue',
    ['isAuthenticated', 'isServedDocumentManagerEnabled', 'canAccessIntakeEvents'],
    '/legal-process/intake-events/my-queue'
  ),
  // "All Intake" is temporarily removed: the all-events list filters/pages on the client and grows unbounded.
  // Restore once the SDM intake lists use server-side filtering/paging (TODO: #12962).
  // new NavbarHeader({
  //   id: NavbarItemId.AllIntake,
  //   groupId: navbarGroupIdServedDocManager,
  //   title: 'All Intake',
  //   elementId: 's_mnu-link-all-intake',
  //   permissionFunction: ['isAuthenticated', 'isServedDocumentManagerEnabled', 'canAccessIntakeEvents'],
  //   link: '/legal-process/intake-events/all-events',
  //   dataTestId: 'navbar-sdm-all-intake-a4d2f8'
  // }),

  new NavbarGroup(navbarGroupIdMatters, 'MATTERS', ['isAuthenticated']),
  new NavbarHeader(NavbarItemId.Unassigned, navbarGroupIdMatters, 'Unassigned', 's_mnu-link-intake', ['isAuthenticated', '!isCurrentUserUploader'], '/legal-process/intake'),
  new NavbarHeader(NavbarItemId.AssignedToMe, navbarGroupIdMatters, 'Assigned to Me', 's_mnu-link-inbox', ['isAuthenticated', '!isCurrentUserUploader'], '/legal-process/my-dashboard/assigned-to-me'),
  new NavbarHeader(105, navbarGroupIdMatters, 'All Matters', 's_mnu-link-cabinet', ['isAuthenticated'], '/legal-process/all'),

  new NavbarGroup(navbarGroupIdRequests, '', ['isAuthenticated']),
  new NavbarHeader(200, navbarGroupIdRequests, 'Recent', 's_mnu-link-recent', ['isAuthenticated'], '/legal-process/my-dashboard/recent'),
  new NavbarHeader(201, navbarGroupIdRequests, 'Starred', 's_mnu-link-starred', ['isAuthenticated'], '/legal-process/my-dashboard/starred'),

  new NavbarGroup(navbarGroupIdAdmin, 'RESOURCES', ['isAuthenticated']),

  new NavbarHeader(410, navbarGroupIdAdmin, 'Library', 's_mnu-link-library', ['isAuthenticated', 'isCurrentUserAdminOrOwner']),
  new NavbarItem(411, 410, 'Internal Resources', '/legal-process/library-documents'),
  new NavbarItem(412, 410, 'Templates', '/legal-process/library-templates'),
  new NavbarItem(413, 410, 'Template (PDF)', '/legal-process/library-templates-pdf', ['isFeatureFlagEnabled|enablePdfTemplates']),
  new NavbarHeader(600, navbarGroupIdAdmin, 'Library', 's_mnu-link-library', ['isAuthenticated', 'isCurrentUserNotAdminOrOwner'], '/legal-process/library-documents'),

  new NavbarHeader(300, navbarGroupIdAdmin, 'Reports', 's_mnu-link-chart', ['isAuthenticated', '!isCurrentUserUploader', 'isCurrentUserPciAuthorized']),
  new NavbarItem(302, 300, 'Reports List', '/legal-process/reports/preconfigured'),
  new NavbarItem(301, 300, 'Data Exports', '/legal-process/reports/export'),

  // Legacy Setup header — preserved verbatim and shown only when Black Mamba is OFF, so the nav is
  // byte-for-byte unchanged from today in that case.
  new NavbarHeader(505, navbarGroupIdAdmin, 'Setup', 's_mnu-link-gear', ['isCurrentUserAdminOrOwner', '!isBlackMambaEnabled'], '/legal-process/system-setup', null, [
    '/settings/cousers',
    '/settings/teams',
    '/settings/general/edit',
    '/legal-process/company-entities',
    '/legal-process/invoice-templates',
    '/legal-process/subfolder-groups',
    '/legal-process/subtypes',
    '/settings/registered-agent-settings',
    '/settings/intake-emails',
    '/settings/serveport-portals',
    '/legal-process/serving-parties',
    '/legal-process/matter-list-config',
    '/legal-process/date-picker-config',
    '/settings/intake-fax',
    '/settings/service-accounts'
  ]),

  // Restructured Setup section — only rendered when Black Mamba is ON. The Setup header is an
  // expandable section visible to all authenticated users, holding three sub-items: My Profile (all
  // users), System Settings (owners/admins — the legacy Setup content and its active-child routes),
  // and Subscriptions (all users). Each sub-item also carries the isBlackMambaEnabled gate so nothing
  // leaks through if the header gate is ever relaxed.
  new NavbarHeader(700, navbarGroupIdAdmin, 'Setup', 's_mnu-link-gear', ['isAuthenticated', 'isBlackMambaEnabled'], '', false, [
    '/legal-process/system-setup',
    '/settings/cousers',
    '/settings/teams',
    '/settings/general/edit',
    '/legal-process/company-entities',
    '/legal-process/invoice-templates',
    '/legal-process/subfolder-groups',
    '/legal-process/subtypes',
    '/settings/registered-agent-settings',
    '/settings/intake-emails',
    '/settings/serveport-portals',
    '/legal-process/serving-parties',
    '/legal-process/matter-list-config',
    '/legal-process/date-picker-config',
    '/settings/intake-fax',
    '/settings/service-accounts',
    '/legal-process/subscriptions'
  ]),
  new NavbarItem(701, 700, 'My Profile', '/settings/cousers/edit/me', ['isAuthenticated', 'isBlackMambaEnabled']),
  new NavbarItem(702, 700, 'System Settings', '/legal-process/system-setup', ['isCurrentUserAdminOrOwner', 'isBlackMambaEnabled']),
  new NavbarItem(703, 700, 'Subscriptions', '/legal-process/subscriptions', ['isAuthenticated', 'isBlackMambaEnabled']),

  ...environmentImports
];
